<template>
    <div id="domainBuild">
        <section class="pb-8 break-words">
            <vs-row class="items-center break-words">
                <div class="flex mt-3">
                    <div v-for="(page, index) in pages" :key="index">
                        <vs-chip :color="page.active ? 'primary' : ''">
                            <b class="m-3">{{page.name}}</b>
                        </vs-chip>

                        <feather-icon
                            class="mt-3 m-1"
                            icon="ArrowRightIcon"
                            v-if="pages.length -1 !== index"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        />
                    </div>
                </div>
   
                <div class="container-width">
                    <CreateDomain :getDomainName="getDomainName" v-if="actualIndexPage === 0" @setName="createDomain"/>
                    <CreateDns :validateDomain="validateDomain" :data="createdDomain" v-if="actualIndexPage === 1" @validate="validate"/>
                    <AuthenticateDomain v-if="actualIndexPage === 2"/>
                </div>
   
                <div class="flex mt-2 container-width">
                    <div class="flex justify-start align-start container-width">
                        <vs-button type="filled" @click.prevent="pageControl('previous')" :disabled="actualIndexPage === 0 || actualIndexPage === 1">
                            <span>Voltar</span>
                        </vs-button>
                    </div>
    
                    <div class="flex justify-end align-end container-width">
                        <vs-button color="primary" @click.prevent="authDomain()" v-if="actualIndexPage === 2">
                            <span>Autenticar Domínio</span>
                        </vs-button>
                        <vs-button v-else color="primary" type="filled" @click.prevent="actualIndexPage === 0 ? pageControl('next', 'create') : (actualIndexPage === 1 ? pageControl('next', 'validate') : pageControl('next'))">
                            <span>{{ actualIndexPage === 1 ? 'Validar DNS' : 'Criar domínio'}}</span>
                        </vs-button>
                    </div>
                </div>
            </vs-row>
        </section>
    </div>
</template>
   
<script>
import AuthenticateDomain from "@/views/domains/stages/AuthenticateDomain.vue";
import CreateDomain from "@/views/domains/stages/CreateDomain.vue";
import CreateDns from "@/views/domains/stages/CreateDns.vue";
import moduleDomain from '@/store/domain/moduleDomain';
import { formatRouteTenantPath} from '@/utils';

export default {
    name: 'HandleDomainStage',
    components: {
        AuthenticateDomain,
        CreateDomain,
        CreateDns
    },
    data() {
        return {
            pages: [
                { name: 'Criação do Domínio', active: true  },
                { name: 'Configuração DNS',  active: false },
                { name: 'Autenticar Domínio',   active: false },
            ],
            getDomainName: false,
            validateDomain: false,
            createdDomain: {}
        }
    },
    computed:{
        actualIndexPage() {
            return this.pages.findIndex((page) => page.active);
        }
    },
    methods: {
        async authDomain() {
            await this.$store.dispatch("domain/auth", this.createdDomain.name)
            .then(
                response => {
                    
                    if (response === "Seu domínio ainda não foi autenticado!") {
                        return this.$vs.notify(
                            {
                                color: 'warning',
                                title: response
                            }
                        );
                    }

                    this.$vs.notify(
                        {
                            color: 'success',
                            title: 'Seu domínio foi autenticado com sucesso!'
                        }
                    );

                    this.$router.push(formatRouteTenantPath('/crm/domain/emails'));
                }
            )
            .catch(
                exception => {
                    console.log(exception);
                }
            );
        },
        pageControl(method, action) {
            if (this.actualIndexPage === 0 && action === 'create') {
                return this.getDomainName = true;
            }
            
            if (this.actualIndexPage === 1 && action === 'validate') {
                return this.validateDomain = true;
            } 

            const actualIndexPage = this.actualIndexPage;
            const increment = method === 'next' ? 1 : -1;
            const newIndexPage = actualIndexPage + increment;

            if (this.pages[newIndexPage]) {
                this.pages[newIndexPage]['active']    = true;
                this.pages[actualIndexPage]['active'] = false;
            }
        },
        async createDomain(name) {
            this.getDomainName = false;
            if (name.length === 0 || name.trim() === '') {
                return this.$vs.notify(
                    {
                        color: 'danger',
                        title: 'Preencha o campo com seu domínio'
                    }
                );
            }

            this.$vs.loading(
                {
                    type: 'radius',
                    container: '#app',
                    clickEffect: true
                }
            );

            await this.$store.dispatch("domain/create", name)
            .then(
                response => {
                    this.createdDomain = response.data.data.createDomain;
                    this.$vs.notify(
                        {
                            color: 'success',
                            title: 'Criado com sucesso!'
                        }
                    );
                    this.pageControl('next');
                }
            )
            .catch(
                exception => {
                    console.log(exception);
                }
            );

            this.$vs.loading.close('#app > .con-vs-loading');
        },
        async validate(name) {
            this.validateDomain = false;

            await this.$store.dispatch("domain/validate", name)
            .then(
                response => {
                    const brevo_validated = response['brevo_validated'];
                    const dkim_validated = response['dkim_validated'];

                    this.createdDomain.brevo_validated = brevo_validated;
                    this.createdDomain.dkim_validated  = dkim_validated;

                    if (brevo_validated && dkim_validated) {
                        this.$vs.notify(
                            {
                                color: 'success',
                                title: 'Ambos os DNS foram validados com sucesso!'
                            }
                        );
                        this.pageControl('next');
                    }
                    else {
                        this.$vs.notify(
                            {
                                color: 'warning',
                                title: (
                                    !brevo_validated && !dkim_validated ? 'Nenhum dos DNS foram validados. '
                                    : (brevo_validated && !dkim_validated ? 'Apenas o registro Brevo foi validado! ' : 'Apenas o registro DKIM foi validado! ')
                                ) + 'Se você configurou corretamente os registros, aguardo mais um pouco e tente novamente mais tarde.',
                                time: 15000
                            }
                        );
                    }
                }
            )
            .catch(
                exception => {
                    console.log(exception);
                }
            );
        }
    },
    mounted() {
        if (!moduleDomain.isRegistered) {
            this.$store.registerModule('domain', moduleDomain);
            moduleDomain.isRegistered = true;
        }
    },
    created() {
        const routeData = this.$route.query.data;

        if (routeData) {
            this.createdDomain = JSON.parse(routeData);
            this.pages[0].active = false;

            if (this.createdDomain.brevo_validated && this.createdDomain.dkim_validated) this.pages[2].active = true;
            else this.pages[1].active = true;
        }
    }
}
</script>
   
<style lang="scss">
#domainBuild {
    .container-width {
        width: 90%;
    }
    .div {
        color: #b3deffa6
    }
}
</style>